export default "__VITE_ASSET___HD9ixuD__"